module.exports = __webpack_public_path__ + "img/block4.e0ae92a4.png";